
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/[locale]/products",
      function () {
        return require("private-next-pages/[region]/[locale]/products/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/[locale]/products"])
      });
    }
  